//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DpFullscreenLoader',
  props: {
    active: { type: Boolean, default: false },
  },
};
